import React from 'react';
import { SvgIcon } from '../svg-icon';
const ControlsAdd = ({ color, size, ...props }) => (React.createElement(SvgIcon, Object.assign({ color: color, viewBox: "0 0 24 24", width: size ? `${size}px` : '24px', height: size ? `${size}px` : '24px' }, props),
    React.createElement("path", { fill: "inherit", d: "M19.225 11.08h-6.75V4.33a.675.675 0 0 0-1.35 0v6.75h-6.75a.675.675 0 0 0 0 1.35h6.75v6.75a.675.675 0 0 0 1.35 0v-6.75h6.75a.675.675 0 0 0 0-1.35Z" })));
ControlsAdd.displayName = 'ControlsAdd'; // Fix for tsc
export default ControlsAdd;
//# sourceMappingURL=ControlsAdd.js.map